import React, { useRef, useEffect } from 'react';
import { Header, Footer } from '@/components';
import HomeBannerView from './home-banner/home-banner.view';
import HomeContentArchero2 from './home-content-archero2/home-content-archero2.view';
import HomeContentCapybara from './home-content-capybara/home-content-capybara.view';
import HomeContentSurvivor from './home-content-survivor/home-content-survivor.view';
//import HomeContentPhilosophy from './home-content-philosophy/home-content-philosophy.view';
import HomeContentArchero from './home-content-archero/home-content-archero.view';
//import HomeContentCulture from './home-content-culture/home-content-culture.view';
//import HomeContentPublish from './home-content-publish/home-content-publish.view';
import useSmoothScroll from '@/hooks/useSmoothScroll';
import useScrollToTop from '@/hooks/useScrollToTop';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const HomeView = () => {
    const containerRef = useRef(null);
    const smoothScrollRef = useRef(null);

    // 使用自定义 Hook，返回是否为移动设备
    const isMobile = useSmoothScroll(smoothScrollRef);
    useScrollToTop();

    useEffect(() => {
        const updateHeight = () => {
            if (!smoothScrollRef.current || isMobile) return;
            
            requestAnimationFrame(() => {
                const container = smoothScrollRef.current;
                const rect = container.getBoundingClientRect();
                const totalHeight = Math.ceil(rect.height) - 2;
                
                document.body.style.height = `${totalHeight}px`;
                
                if (process.env.NODE_ENV === 'development') {
                    console.log('Home page height:', {
                        totalHeight,
                        rectHeight: rect.height
                    });
                }
            });
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        
        const resizeObserver = new ResizeObserver(updateHeight);
        if (smoothScrollRef.current) {
            resizeObserver.observe(smoothScrollRef.current);
        }

        return () => {
            window.removeEventListener('resize', updateHeight);
            resizeObserver.disconnect();
            // 重置 body 高度
            document.body.style.height = '';
        };
    }, [isMobile]);

    return (
        <>
            <Header />
            <div
                ref={containerRef}
                style={{
                    position: isMobile ? 'relative' : 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    willChange: isMobile ? 'auto' : 'transform',
                    backfaceVisibility: isMobile ? 'visible' : 'hidden',
                    perspective: isMobile ? 'none' : 1000
                }}
            >
                <div ref={smoothScrollRef} className="default-view">
                    <HomeBannerView />
                    <HomeContentArchero2 />
                    <HomeContentCapybara />
                    <HomeContentSurvivor />
                    <HomeContentArchero />
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default HomeView;
